// Reusable helpers for Payment Request domain (sline, additional-task, expense)

export const PaymentTypes = {
  SLINE: 0,
  EXPENSE: 1,
  ADDITIONAL_TASK: 2,
}

export function buildPurchaseExpenseQuery({
  moduleId=null,
  paymentType=null,
  includeChildren = false,
  is_children=false,
  is_parent=false,
  apeId=null,
  parentApeId=null,
  transactionNo=null,
  isPaymentDone=false,
}) {
  const payload = {
    fk_module_id: moduleId != null ? Number(moduleId) : undefined,
    payment_type: paymentType,
    // Controller supports multiple knobs; keep includeChildren for compatibility
    includeChildren: is_children === true ? true : includeChildren,
    is_children: is_children === true ? 1 : (is_children === false ? 0 : undefined),
    is_parent: typeof is_parent === 'boolean' ? (is_parent ? 1 : 0) : undefined,
    ape_id: apeId != null ? Number(apeId) : undefined,
    fk_parent_id: parentApeId != null ? Number(parentApeId) : undefined,
    ape_transaction_no: transactionNo || undefined,
  }
  if (typeof isPaymentDone === 'boolean') {
    payload.is_payment_done = isPaymentDone ? 1 : 0
  }
  return payload
}

export function mapNodePurchaseExpenseToAddTaskRow(element) {
  return {
    ape_transaction_no: element.ape_transaction_no || '',
    ape_id: element.ape_id || '',
    allModuleId: element.fk_module_id || '',
    addTask_ledgerId: element.fk_ledger_id || '',
    addTask_amount: element.inv_amt != null ? element.inv_amt : '',
    addTask_currency_id: element.fk_currency_id || '',
    addTask_remark: element.sc_remark || '',
    addTask_scCategory: element.sc_category || '',
    addTask_selling_amt: element.selling_amt != null ? element.selling_amt : '',
    addTask_payStatus: '',
    approval_status: element.approval_status || '',

    // errors
    addTask_ledgerId_err: '',
    addTask_amount_err: '',
    addTask_currency_id_err: '',
    addTask_remark_err: '',
    addTask_scCategory_err: '',
    addTask_selling_amt_err: '',
    addTask_payStatus_err: '',
  }
}


// UI formatting helpers reused across components

// Keep only digits and a single dot, and limit to two decimal places (no rounding)
export function sanitizeTwoDecimalInput(value) {
  if (value === null || value === undefined) return '';
  let v = String(value);
  v = v.replace(/[^0-9.]/g, '');
  const parts = v.split('.');
  if (parts.length > 2) {
    v = parts[0] + '.' + parts.slice(1).join('');
  }
  const [intp, decp = ''] = v.split('.');
  const trimmed = decp.length > 2 ? decp.slice(0, 2) : decp;
  return decp.length ? `${intp}.${trimmed}` : intp;
}

// Return a string fixed to 2 decimals, or null if not a number
export function toFixedTwo(value) {
  if (value === '' || value === null || value === undefined) return null;
  const num = Number(value);
  if (!isNaN(num)) {
    return num.toFixed(2);
  }
  return null;
}

// Validate if a string matches up to 2 decimal places pattern
export function isValidTwoDecimal(value) {
  const val = value == null ? '' : String(value);
  const regex = /^(\d+\.?\d{0,2})?$/;
  return regex.test(val);
}

// Prevent mouse wheel from changing number input when focused
export function preventWheelChange(event) {
  if (event && document.activeElement === event.target) {
    event.preventDefault();
  }
}



// WEBPACK FOOTER //
// ./src/helper/PaymentHelper.js